import { Component, OnInit } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';

@Component({
    selector: 'lib-divider',
    templateUrl: './divider.component.html',
    styleUrls: ['./divider.component.scss'],
    host: {
        style: 'display:contents'
    }
})
export class DividerComponent {

}
